import React, { useId, useRef } from 'react';

import { Button, Heading, Popup, PopupSection } from '@flixbus/honeycomb-react';

import { DELETE_CONFIRMATION_MODAL_TEXT } from './text';
import { getDeleteConfirmationText } from './utils';

import styles from './styles.module.css';

const DeleteConfirmationModal = ({
	active,
	cancelLabel = DELETE_CONFIRMATION_MODAL_TEXT.cancelButton,
	confirmLabel = DELETE_CONFIRMATION_MODAL_TEXT.confirmButton,
	extraLabel,
	itemLabel = DELETE_CONFIRMATION_MODAL_TEXT.defaultItemLabel,
	loading,
	onCancel,
	onConfirm,
	title = DELETE_CONFIRMATION_MODAL_TEXT.defaultTitle,
}) => {
	const targetRef = useRef(null);
	const id = `delete-confirmation-${useId()}`;
	const description =
		extraLabel || itemLabel !== DELETE_CONFIRMATION_MODAL_TEXT.defaultItemLabel
			? getDeleteConfirmationText({ itemLabel, extraLabel })
			: DELETE_CONFIRMATION_MODAL_TEXT.defaultDescription;

	return (
		<Popup
			id={id}
			aria-labelledby={`${id}-header`}
			aria-describedby={`${id}-content`}
			active={active}
			onOverlayClick={onCancel}
			targetRef={targetRef}
		>
			<PopupSection type="title">
				<Heading id={`${id}-header`} size={1} sectionHeader>
					{title}
				</Heading>
			</PopupSection>

			<PopupSection type="content" id={`${id}-content`}>
				<div className={styles.description}>{description}</div>
			</PopupSection>

			<PopupSection type="actions">
				<Button type="button" onClick={onCancel}>
					{cancelLabel}
				</Button>
				<Button type="button" appearance="danger" onClick={onConfirm} loading={loading}>
					{confirmLabel}
				</Button>
			</PopupSection>
		</Popup>
	);
};

export default DeleteConfirmationModal;
